import * as Sentry from "@sentry/react-native";

import { getRuntimeInfo } from "./runtime-info";

/**
 * Makes every Sentry event filterable by what was running. The SDK already attaches the update id as an
 * unsearchable context; tags are searchable. `app.platform` is ios/android/web (Sentry's own `platform`
 * is "javascript" for web events).
 */
export function tagSentryRuntime() {
  const info = getRuntimeInfo();
  Sentry.setTags({
    "app.platform": info.platform,
    "app.native_version": info.nativeVersion ?? "unknown",
    "app.native_build": info.nativeBuild ?? "unknown",
    "app.update_id": info.isEmbeddedLaunch
      ? "embedded"
      : (info.updateId ?? "unknown"),
    "app.update_channel": info.channel ?? "none",
    "app.runtime_version": info.runtimeVersion ?? "none",
  });
}
